module.exports = __webpack_public_path__ + "static/media/thumbnail.36f5973c.jpg";